module.exports = __webpack_public_path__ + "static/media/forward.cf08a44c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forward.svg
// module id = 40
// module chunks = 0